<!--Update Fleet User Title-->
<h2>Update Fleet User</h2>
<p>Customer ID: {{updateFleetUserRequest.customerId}}</p>
<p>User Email: {{updateFleetUserRequest.userEmail}}</p>
<p>Fleet Kind: {{updateFleetUserRequest.fleetKind}}</p>
<mat-dialog-content>
    <!--Dialog Content-->
    <div *ngIf="!updateFleetUserResponse">
        <form novalidate>
            <div>
                <section>
                    <mat-checkbox [(ngModel)]="updateFleetUserRequest.isEnabled"
                        [ngModelOptions]="{standalone: true}">Enabled</mat-checkbox>
                </section>
            </div>            
        </form>
    </div>
    <div *ngIf="updateFleetUserResponse">
        <label>User Id: {{updateFleetUserResponse.fleetUser?.userId}}</label> <br />
    </div>
</mat-dialog-content>
<mat-dialog-actions>
    <!--Dialog action buttons-->
    <button mat-raised-button color="primary" (click)="save()" [disabled]="isSaving"
        *ngIf="!updateFleetUserResponse">
        <span *ngIf="!isSaving">Save</span>
        <span *ngIf="isSaving">Saving...</span>
    </button>
    <button mat-raised-button [disabled]="isSaving" (click)="close()">Cancel</button>
</mat-dialog-actions>